import { ds } from "js/core/models/dataService";
import { FallbackCanvas } from "./fallbackCanvas";
import log from "js/core/logger";
import { $ } from "js/vendor";
import { Presentation } from "../core/models/presentation";
import { trackActivity } from "js/core/utilities/utilities";
import { PlayerView } from "js/player/playerView";
import { THUMBNAIL_SIZES } from "common/constants";

export const FallbackPlayerView = PlayerView.extend({
    isFallbackPlayer: true,

    loadPresentationId: function(presentationId, startSlideIndex = 0) {
        let attemptReload = false;

        if (!presentationId) {
            return this.showNotPermittedWarning();
        }

        this.presentation = new Presentation({ id: presentationId });
        return this.presentation
            .load()
            .then(() => {
                // this.playerUI.presentation = this.presentation;
                ds.selection.presentation = this.presentation;
                if (this.presentation.permissions.collaborator) {
                    trackActivity("Collab", "ViewPresentation", this.presentation.id);
                }
                window.document.title = "Beautiful.ai - " + this.presentation.get("name");
                const waitForPlainProperties = true;
                const options = { assetsLoaded: true };

                return this.presentation
                    .prepareSlides(waitForPlainProperties, options)
                    .then(async () => {
                        // add slides
                        this.slides = [];

                        for (let i = 0; i < this.presentation.slides.length; i++) {
                            let slide = this.presentation.slides.at(i);
                            if (slide.hasMultipleStages()) {
                                const playbackStageCount = slide.getPlaybackStageCount();
                                for (let j = 0; j < playbackStageCount; j++) {
                                    let thumbnailIndex = j === 0 ? undefined : j;
                                    const imageUrl = await slide.getThumbnailUrl(this.presentation.id, "large", thumbnailIndex);
                                    this.slides.push(
                                        this.addSlide(slide, imageUrl, j)
                                    );
                                }
                            } else {
                                const imageUrl = await slide.getThumbnailUrl(this.presentation.id, "large");
                                this.slides.push(
                                    this.addSlide(slide, imageUrl, 0)
                                );
                            }
                        }

                        this.setSlides(this.slides);
                        const playableSlideIndex = this.goToPlayableSlide(
                            +1,
                            startSlideIndex
                        );

                        if (this.slides.length && playableSlideIndex < this.slides.length) {
                            this.playPresentation(playableSlideIndex);
                        } else {
                            this.$el.spinner(false);
                            this.hideSlides();
                            return Promise.resolve();
                        }
                    });
            })
            .catch(err => {
                log.error(err);
            });
    },

    renderPlayButton(onClickHandler) {
        this.$playButton = this.$container.addEl($.div("fallback-warning"));
        this.$playButton.append($.icon("play_circle_filled"));

        let $frame = this.$playButton.addEl($.div("frame"));
        $frame.append(
            $.div(
                "",
                "Some playback features are not supported in this browser. For the full playback experience, please use Google Chrome when viewing this presentation."
            )
        );

        this.$playButton.on("click", event => {
            event.stopPropagation();
            onClickHandler && onClickHandler();
            this.$playButton.remove();
            this.$playButton = null;
        });
    },

    addSlide: function(slideModel, imageUrl, index) {
        var slide = {
            model: slideModel
        };

        log.debug(log.PLAYER)(
            "Adding template type: " + slide.model.get("template_id")
        );

        // create the slideCanvas
        slide.canvas = new FallbackCanvas({
            model: slide.model,
            canvasWidth: this.CANVAS_WIDTH,
            canvasHeight: this.CANVAS_HEIGHT,
            editable: false,
            isPlayback: true,
            index,
            imageUrl
        });

        slide.canvas.slide = slideModel;
        // prepare to transition fade in
        slide.canvas.$el.opacity(0);

        return slide;
    }
});
